import React, { memo } from 'react';
import { useSelector } from 'react-redux';

import { Box, Typography } from '@mui/material';
import _ from 'lodash';

import { formatNumberToCurrencyString } from 'utils/number';

import { selectUnderwritingQualificationDetails } from 'store/loanApplications/selectors';

import { NOT_APPLICABLE } from './QualificationDetails.constants';

const QualificationDetails = () => {
  const {
    duMonths,
    duAssetsToVerifyAmount,
    lpMonths,
    lpRequiredReservesAmount,
    cashFromToBorrower,
    householdTotalAssets,
  } = useSelector(selectUnderwritingQualificationDetails) || {};

  const hasLpValue = _.isNumber(lpRequiredReservesAmount) && _.isNumber(lpMonths);
  const hasDuValue = _.isNumber(duAssetsToVerifyAmount) && _.isNumber(duMonths);

  const lpValue = `LP: ${formatNumberToCurrencyString(lpRequiredReservesAmount)} / ${lpMonths}`;
  const duValue = `DU: ${formatNumberToCurrencyString(duAssetsToVerifyAmount)} / ${duMonths}`;

  const lpValueToDisplay = hasLpValue ? lpValue : NOT_APPLICABLE;
  const duValueToDisplay = hasDuValue ? duValue : NOT_APPLICABLE;

  return (
    <Box className="flex flex-col gap-5">
      <Box className="flex flex-col">
        <Typography variant="regular14">{lpValueToDisplay}</Typography>
        <Typography variant="regular14">{duValueToDisplay}</Typography>
      </Box>

      <Box className="flex flex-col">
        <Typography variant="regular14">
          Total assets: {formatNumberToCurrencyString(householdTotalAssets)}
        </Typography>
        <Typography variant="regular14">
          Cash From/To Borrower: {formatNumberToCurrencyString(cashFromToBorrower)}
        </Typography>
      </Box>
    </Box>
  );
};

export default memo(QualificationDetails);
